import { useGetEntityDataAttributesQuery } from "store/apis/entity";
import { useCurrentGroupContext } from "./useCurrentGroupContext";
import dayjs from "dayjs";

export const useCurrentYearIncorporate = () => {
  const { entities, uuid: groupId } = useCurrentGroupContext();
  const entityId = entities.find(
    (entity) => entity.country_code === "US"
  )?.uuid;

  const { data } = useGetEntityDataAttributesQuery(
    {
      groupId,
      entityId: entityId!,
    },
    {
      skip: !groupId || !entityId,
    }
  );

  const dateOfIncorporation = data?.find(
    (field) => field.name === "date_of_incorporation"
  )?.value;

  if (!dateOfIncorporation) {
    return false;
  }

  const isCurrentYear =
    dayjs(dateOfIncorporation as string).year() === dayjs().year();

  return isCurrentYear;
};
